import ApiService from '../apiservice'

export default class CheckListAtividadeService extends ApiService {
  constructor() {
    super('/checkListAtividade')
  }

  cadastrar(checkList) {
    return this.post('/',checkList);
  }

  listar(atividade) {
    return this.get(`/listar/${atividade}`);
  }

  alterar(checkList) {
    return this.put('/',checkList);
  }

  excluir(codigo) {
    return this.delete(`/delete/${codigo}`);
  }
}